export default "__VITE_ASSET__C_W03ee6__"